import { render, staticRenderFns } from "./manage-self-assessment-activity.vue?vue&type=template&id=c473e22a"
import script from "./manage-self-assessment-activity.vue?vue&type=script&lang=js"
export * from "./manage-self-assessment-activity.vue?vue&type=script&lang=js"
import style0 from "./manage-self-assessment-activity.vue?vue&type=style&index=0&id=c473e22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports